import { Pagination } from "@/interfaces/paginatedResponse";
import { Brand } from "@/internal/modules/providers/interfaces/Brand";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useChainBrandsStore = defineStore("chainBrands", () => {
  const chainBrands = ref<Brand[]>([]);
  const pagination = ref<Pagination>();

  return {
    chainBrands,
    pagination,

    setChainBrands(brands: Brand[]) {
      chainBrands.value = brands;
    },
    setPagination(paginationData: Pagination) {
      pagination.value = paginationData;
    },
  };
});
